import React from 'react';
import {ScrollView, View} from 'react-native';

/** Minimum table width kept while horizontally scrolling (px). */
const MIN_TABLE_WIDTH = 960;

/**
 * Data tables (list views) cannot be reflowed into 320 px, and WCAG 1.4.10
 * exempts two-dimensional data tables. At extreme zoom the table therefore
 * scrolls sideways inside its own container instead of overflowing the page.
 * Renders its children untouched when not zoomed.
 */
export const ZoomedHorizontalScroll: React.FC<{
  enabled: boolean;
  children: React.ReactNode;
  /** Minimum inner width in px (defaults to a wide data-table width). */
  minWidth?: number;
}> = ({enabled, children, minWidth = MIN_TABLE_WIDTH}) => {
  if (!enabled) {
    return <>{children}</>;
  }
  return (
    <ScrollView horizontal showsHorizontalScrollIndicator>
      <View style={{minWidth}}>{children}</View>
    </ScrollView>
  );
};
